var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "", "align-center": "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", md6: "", lg3: "" } },
        [
          _c("ClientFilter", {
            model: {
              value: _vm.client,
              callback: function($$v) {
                _vm.client = $$v
              },
              expression: "client"
            }
          })
        ],
        1
      ),
      _vm.client
        ? _c(
            "v-flex",
            { attrs: { xs12: "", md6: "", lg3: "" } },
            [
              _c("FlotaFilterAutocomplete", {
                attrs: { clientRut: _vm.client.rut },
                model: {
                  value: _vm.flota,
                  callback: function($$v) {
                    _vm.flota = $$v
                  },
                  expression: "flota"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("v-flex", { attrs: { xs12: "", md6: "", lg3: "" } }, [
        _c(
          "div",
          { staticClass: "text-sm-center" },
          [
            _c(
              "v-btn",
              {
                attrs: { flat: "", icon: "", small: "" },
                on: { click: _vm.handleBuscarClick }
              },
              [_c("v-icon", [_vm._v("search")])],
              1
            ),
            _c(
              "v-btn",
              {
                attrs: { flat: "", icon: "", small: "" },
                on: { click: _vm.clearFilters }
              },
              [_c("v-icon", [_vm._v("clear")])],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }